import { module } from 'modujs';
import modularLoad from 'modularload';
import shared from '../shared';
import { $body } from '../utils/dom';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 1500,
            transitions: {
                home: {
                    enterDelay: 1500,
                }
            }
        });

        this.DOM = {
            loading: document.querySelector('.o-loading'),
            loadingLogo: document.querySelector('.o-loading_logo'),
            loadingBaseline: document.querySelector('.o-loading_baseline')
        };

        window.addEventListener('hide-loading', () => { this.hide(); });

        this.load.on('loading', (oldContainer, newContainer) => {
            this.show();
            this.call('stop', 'Scroll');
        });

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            if (transition === 'home') {
                location.reload(true);
                return;
            }
            
            shared();

            // Update body class
            this.setNewBodyClass();
            this.hide();
            
            window.dispatchEvent(new Event("p-loaded"));

            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');
        });
        
    }

    show () {
        this.call('stop', 'Scroll');
        this.DOM.loading.classList.remove('-hidden');

        gsap.fromTo(this.DOM.loading,
            { clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)' },
            { clipPath: 'polygon(0 -1%, 100% -1%, 100% 100%, 0 100%)', duration: 1, ease: "expo.inOut" }
        );
        gsap.to(this.DOM.loadingBaseline.querySelectorAll('.char'), { opacity: 1, duration: 0.25, delay: 0.6, ease: "none", stagger: {each: 0.02, from: 'random'}  });
        gsap.to(this.DOM.loadingLogo, { opacity: 1, scale: 1, duration: 0.6, delay: 0.6, ease: "power4.out" });
    }

    hide (delay = 0) {        
        gsap.to(this.DOM.loadingBaseline.querySelectorAll('.char'), { opacity: 0, duration: 0.4, ease: "none", stagger: {each: 0.02, from: 'random'} });
        gsap.to(this.DOM.loadingLogo, { opacity: 0, scale: 0.8, duration: 0.4, delay: 0.4, ease: "power4.out" });
        gsap.fromTo(this.DOM.loading,
            { clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' },
            { clipPath: 'polygon(0 0, 100% 0, 100% -1%, 0 -1%)', duration: 1, ease: "expo.inOut", delay: 0.6, onComplete: () => {
                this.DOM.loading.classList.add('-hidden');
                this.call('start', 'Scroll');
                gsap.set(this.DOM.loading, { clearProps: "all" });
            } }
        );
        
        setTimeout(() => {
            // Animate page content
            window.dispatchEvent(new Event("p-animate"));
        }, 1200);
    }

    setNewBodyClass () {
        if (this.el.querySelector('[data-bodyclass]')) {
            let bodyClass = this.el.querySelector('[data-bodyclass]').getAttribute('data-bodyclass');
            $body.className = bodyClass;
        }
    }
}
